<template>
  <b-container fluid>
    <b-row>
      <b-col v-if="loading">
      ...
      </b-col>
      <b-col v-else v-for="(item, index) in itemsWithDictionaryValue" :key="item.id"
             :class="clazz"
             cols="auto">
        <span style="display: inline-flex">{{item.name}} : </span>
        <span v-if="item.type === 'Text' || item.type === 'Long text' || item.type === 'Integer' || item.type === 'Decimal' || item.type === 'Date'
        || item.type === 'Checkbox' || item.type === 'Color picker'" style="display: inline-flex"
              class="readonly-input">{{item.value}}</span>
        <span
            v-if="(item.type === 'Decimal with unit' || item.type === 'Currency') && item.value && item.value.currency && item.value.currency.name"
            class="readonly-input"
            style="display: inline-flex"
        >
          {{item.value.decimal}} {{item.value.currency.name}}
        </span>
        <span v-if="item.type === 'Dictionary'" class="readonly-input"
              style="display: inline-flex">{{ item.__dictionaryValue }}</span>
        <span v-if="items && items.length - 1 > index">|</span>
      </b-col>
      <!--      <span v-if="items && items.length > 4">  (+{{items.length - 4}})</span>-->
    </b-row>
  </b-container>
</template>


<script>
import FormsLoader from "@/components/forms/FormsLoader";
import Dictionary from "@/server/com/silkplm/engine/model/Dictionary";
import Product from "@/server/com/silkplm/model/plm/Product";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import CacheManager from "@/components/cacheManager/CacheManager";
import {sortDynamicAttributes} from "@/components/cacheManager/DynamicAttributesSorter";

export default {
  name: "ValueAttributesGrid",

  async created() {
    await this.refresh();
  },

  async mounted(){
    this.$onUpdate(Product, async (changeEvent) => {
      if(changeEvent.id === this.model.id){
        this.items = changeEvent.instance.productCategoryAttributes;
        await this.getValues();
      }
    });

    this.$onBulkChange(Product, async (changeEvent) => {
      this.items = this.model[this.prop];
      await this.getValues();
    });



  },

  methods: {

    async getValues(){
      if(!this.items){
        return;
      }
      try {
        this.loading = true;
        let tasks = [];
        if (this.items) {
          await sortDynamicAttributes(this.items);
        }
        for (let el of this.items) {
          if (el.type === "Dictionary") {
            const call = async () => {
              let dynamicDictionaries = await CacheManager.getDynamicDictionaries();
              if (!dynamicDictionaries.hasOwnProperty(el.dictionaryId)) {
                return;
              }
              let dict = dynamicDictionaries[el.dictionaryId];
              let clazz = FormsLoader.detectFormConfig(dict.formId).formClassLong;
              if(el.__dictionaryValue == null) {
                el.__dictionaryValue = await Rpc.Forms.getDynamicEntityLabel(clazz, el.value);
              }
            }
            tasks.push(call());
          }
        }
        await Promise.all(tasks);

        this.itemsWithDictionaryValue = this.items;
      } finally {
        this.loading = false;
      }
    },

    async refresh(){
      this.items = this.model[this.prop];
      await this.getValues();
    }

  },

  watch: {
    model: function(val){
      this.refresh();
    },
    prop: function(val){
      this.refresh();
    }
  },

  props: ["rowIndex", "prop", "model", "column"],

  data: () => ({
    clazz: SessionManager.hasFlag(FeatureFlag.GRID_V3) ?
        "pr-1 pl-0" :
        //"align-items-center ml-1 pl-2 m-0 text-left align-middle text-pills-pill border rounded-lg rounded-pill border-secondary pr-2":
        "pr-1 pl-0",
    loading: false,
    items: [],
    itemsWithDictionaryValue: null
  })

}
</script>

<style scoped>

</style>